import type { RefOrGetter } from "ls/common/types";
import ky from "ky";
import { miniProfilerResponseHook, parseCloudJsonResponse, problemDetailsErrorHook } from "ls/api/common/server";
import { shallowRef, toValue, watch } from "vue";
import { authToken } from "./authTokenStorage";

function create(baseUrl?: string) {
  const instance = ky.create({
    prefixUrl: baseUrl,
    credentials: "include",
    timeout: import.meta.env.DEV ? false : undefined,
    retry: { limit: 0 },
    parseJson: parseCloudJsonResponse,
    hooks: {
      beforeRequest: [
        request => {
          const token = authToken.get();
          if (token) {
            request.headers.set("Authorization", token);
          }
        },
      ],
      afterResponse: [
        miniProfilerResponseHook,
      ],
      beforeError: [
        problemDetailsErrorHook,
      ],
    },
  });

  return instance;
}

export function useServerInstance(baseUrl: RefOrGetter<string | undefined>) {
  const instance = shallowRef(create(toValue(baseUrl)));

  watch(baseUrl, url => {
    instance.value = create(url);
  });

  return instance;
}
